export default "__VITE_ASSET__m$CZu6YU__"